import React from 'react'; // eslint-disable-line no-unused-vars
import ReactDOM from 'react-dom'; // eslint-disable-line no-unused-vars

class Abstract {
	constructor(config) {
		this.config = config;

		this.root = this.config.root;
		this.props = this.config.props;
	}

	getState = (reducer) => {
		const { component, store } = this.config;

		if (store) {
			return store.getState()[reducer];
		}

		throw Error(`${component} does not have access to Redux state.`);
	}

	subscribe = (callback) => {
		const { component, store } = this.config;

		if (store) {
			return store.subscribe(callback);
		}

		throw Error(`${component} cannot subscribe to Redux`);
	}

	dispatch = (action) => {
		const { store } = this.config;

		if (store) {
			store.dispatch(action);
		}
	}

	setupObjectFit = () => {
		if (!window.objectFitPolyfill || typeof window.objectFitPolyfill !== 'function') return;

		window.objectFitPolyfill(this.root.querySelectorAll('[data-object-fit]'));
	}
}

export default Abstract;
